import { Component, h, VNode } from 'preact';

import PartyPill from './PartyPill';

interface Props {
  ballotName: string;
  isIncumbent: boolean;
  party: string;
}

class CandidateRow extends Component<Props> {
  static Header: VNode;
  static countyHeader: VNode;
  static columnCount: number;

  render() {
    const {
      ballotName,
      isIncumbent,
      party,
    } = this.props;


    return (
      <tr class="candidate contest__candidate-row">
        <td class="candidate__cell candidate__party">
          {<PartyPill party={party} />}
        </td>
        <th class="candidate__cell candidate__name">
          {ballotName}{' '}
          {isIncumbent && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
      </tr>
    );
  }
}

CandidateRow.defaultProps = {
  contestIsCalled: false,
  isViewable: true,
};

CandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
    </tr>
  </thead>
);

CandidateRow.countyHeader = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
    </tr>
  </thead>
);

CandidateRow.columnCount = 2;

export default CandidateRow;